module.exports = __webpack_public_path__ + "img/voltar.853fa6ba.svg";